import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { PermissionsService } from '../permissions/permissions.service';

@Injectable()
export class AiAssistantGuardService {
    constructor(
        private router: Router,
        private permissionsService: PermissionsService,
    ) {}

    public canActivate(): boolean | UrlTree {
        return (
            this.permissionsService.checkPermission({
                name: 'ai_assistant',
            }) || this.router.parseUrl('/error/403')
        );
    }
}
